import { useCallback, useEffect, useState } from 'react';
import api from '@/utils/api';
import { getErrorMessage } from '@/utils/error';

export interface Company {
  orgId: number;
  userId: string;
  name: string;
  address?: string;
  city?: string;
  country?: string;
  industry?: string;
  linkedinUrl?: string;
  website?: string;
  wizardCompleted: boolean;
  wizardStep: number;
  contentTypes?: string[];
  description?: string;
  serviceDescription?: string;
  productOrService?: 'Product' | 'Service';
  brandColors?: { primary?: string; secondary?: string; accent?: string };
  logoUrl?: string;
  brandGuidelines?: string;
  createdAt: Date | string;
  updatedAt: Date | string;
}

export const useOrgId = () => {
  const [orgId, setOrgId] = useState<number | undefined>(undefined);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchOrgId = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const { data } = await api.get<Company[]>('/company');
      if (data && data.length > 0) {
        setOrgId(data[0].orgId);
      } else {
        setError('No company found for user');
      }
    } catch (err: unknown) {
      setError(getErrorMessage(err));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchOrgId();
  }, [fetchOrgId]);

  return {
    orgId,
    loading,
    error,
    refetch: fetchOrgId,
  };
};

